<template>
    <div>
        <h2 id="sign-in-prompt-title" class="text-lg font-bold tracking-tight">Sign in to hold this slot</h2>
        <p class="mt-1 text-base text-gray-600">{{ slotLabel }} We'll bring you straight back here.</p>

        <Link
            :href="loginUrl"
            class="w-full h-14 mt-3.5 flex items-center justify-center rounded-[0.625rem] bg-primary text-sm font-bold uppercase tracking-widest text-white transition hover:bg-tertiary hover:text-black focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
        >
            Sign in
        </Link>
        <Link
            :href="registerUrl"
            class="w-full h-14 mt-2 flex items-center justify-center rounded-[0.625rem] border-[1.5px] border-gray-300 bg-white text-sm font-bold uppercase tracking-widest text-gray-900 transition hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
        >
            Create an account
        </Link>
        <button
            type="button"
            class="w-full h-12 mt-1.5 flex items-center justify-center rounded-[0.625rem] text-sm font-semibold text-gray-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
            @click="$emit('close')"
        >
            Keep looking
        </button>
    </div>
</template>

<script setup>
    import { computed } from "vue";
    import { Link } from "@inertiajs/vue3";
    import { formatHourLong } from "../../Composables/useBookingSchedule.js";
    import { bookingReturnPath } from "../../Helpers/BookingReturn.js";

    /**
     * What we ask a signed-out visitor, and where the two links go. Both widths show this — the
     * phone in a bottom sheet, the desktop in a centred modal — so the promise it makes and the
     * URL that has to keep it live in one place rather than being restated per breakpoint.
     */
    const props = defineProps({
        space: Object,
        currentDay: Object,
        startTime: Number,
    });

    defineEmits(["close"]);

    const slotLabel = computed(() =>
        props.space && props.startTime !== null && props.currentDay
            ? `${props.space.name} · ${props.currentDay.toFormat("ccc d LLL")} · ${formatHourLong(props.startTime)}.`
            : "",
    );

    // Come back to the slot, not just the page. The bare redirect to /login dropped the visitor
    // on the dashboard; landing them back on the calendar with nothing selected is barely better.
    const returnTo = computed(() =>
        bookingReturnPath({ space: props.space, day: props.currentDay, hour: props.startTime }),
    );

    const loginUrl = computed(() => `/login?redirect=${encodeURIComponent(returnTo.value)}`);
    const registerUrl = computed(() => `/register?redirect=${encodeURIComponent(returnTo.value)}`);
</script>
